import { Signal } from '@angular/core';
import { syncState } from '../internal/signal/sync-state';
import { createState, createStateInjector, createStateProvider, createStateToken } from '../state';
import type { UiButtonDirective } from './button.directive';

/**
 * The state token  for the Button primitive
 */
export const uiButtonStateToken = createStateToken<UiButtonDirective>('Button');

/**
 * Provides the Button state
 */
export const provideUiButtonState = createStateProvider(uiButtonStateToken);

/**
 * Injects the Button state
 */
export const injectUiButtonState = createStateInjector(uiButtonStateToken);

/**
 * The Button state registration function
 */
export const uiButtonState = createState(uiButtonStateToken);

interface SyncUiButton {
    disabled: Signal<boolean>;
}

/**
 * Sync the button state with control state.
 * @param disabled The disabled state of the control.
 */
export function syncUiButton({ disabled }: SyncUiButton) {
    const button = injectUiButtonState();

    syncState(disabled, button().disabled);
}
